// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/attachments/attachments.component.scss
// module id = 119
// module chunks = 0